<script>
	import { Router, Route, Link } from "svelte-routing";
	import Home from "./pages/Home.svelte";
	import Clients from "./pages/Clients.svelte";
	import ImportRecords from "./pages/ImportRecords.svelte";
	import Stock from "./pages/Stock.svelte";
	import StockB2B from "./pages/StockB2B.svelte";
	import Reports from './pages/Reports.svelte';
	import ReportsB2B from './pages/ReportsB2B.svelte';
	import Stockb2bOtrs from './pages/Stockb2bOtrs.svelte';
	import Stockb2bOfficeTrack from './pages/Stockb2bOfficeTrack.svelte';
	import Login from "./pages/Login.svelte";
	import { logout } from "./services/Auth";
	import Authguard from "./services/Authguard.svelte";
	export let url = "";
</script>

<Router {url}>
	<Authguard>
		<span slot="authorized" style="padding: 0">
			<nav
				class="navbar navbar-expand-lg navbar-danger bg-danger"
				style="margin-bottom: 15px">
				<a
					class="navbar-brand"
					style="color: #fff; font-weigth: bold"
					href="/">Auxiliador</a>
				<span on:click={logout} style="color: #fff; font-weigth: bold">
					Sair
				</span>
			</nav>
			<Route path="/">
				<Home />
			</Route>
			<Route path="/clients">
				<Clients />
			</Route>
			<Route path="/importrecords">
				<ImportRecords />
			</Route>
			<Route path="/stock">
				<Stock />
			</Route>
			<Route path="/stockb2b">
				<StockB2B />
			</Route>
			<Route path="/reports">
				<Reports />
			</Route>
			<Route path="/reportsB2B">
				<ReportsB2B />
			</Route>
			<Route path="/Stockb2bOtrs">
				<Stockb2bOtrs />
			</Route>
			<Route path="/Stockb2bOfficeTrack">
				<Stockb2bOfficeTrack />
			</Route>
		</span>

		<span slot="unauthorized" style="height: 100%">
			<div style="height: 100%">
				<Route path="/">
					<Login />
				</Route>
				<Route path="/clients/*" redirect="/" />
			</div>
		</span>
	</Authguard>
</Router>
